import { Button } from 'antd';
import { PesticidesMap } from './map/index';
import style from './style.module.css';
import { useGetTerritorialUnitsGetpolygonsListQuery } from "../../../redux/api/handBooksApi/territorialUnitsApi";
import { EntTerritorialUnitsFilter } from "../../../models/filters/territorialUnitsFilter";
import { useGetPesticidesListtQuery } from "./api";
import { useTranslation } from 'react-i18next';
import { useState, useCallback } from 'react';
import { PreloaderSvg } from '../../preloaderSvg/PreloaderSvg';
import { PlusOutlined } from '@ant-design/icons';
import ReportChemicalization from '../../../pages/admin/chemicalization/reportChemicalization/ReportChemicalization';
import { useReportPesticidesMutation } from '../../../redux/api/chemicalization/pesticides';

export const PesticidesBlock = () => {
    const { t } = useTranslation();
    const [selectedYear, setSelectedYear] = useState<number | null>(null);
    const [selectedRegionId, setSelectedRegionId] = useState<number | undefined>();
    const [selectedRegionName, setSelectedRegionName] = useState<string>("");
     const [showReportModal, setShowReportModal] = useState<boolean>(false);
        const { data: polygonsData, isLoading: polygonsLoading } = useGetTerritorialUnitsGetpolygonsListQuery(
        new EntTerritorialUnitsFilter({ page: 1, size: 15 })
    );
    const { data: pesticidesData, isLoading: isLoadingPesticides } = useGetPesticidesListtQuery({
        year: selectedYear ? selectedYear.toString() : undefined,
        territorialUnitId: selectedRegionId || 0,
    });

    const handleRegionClick = useCallback((regionId: number, regionName: string) => {
        setSelectedRegionId(regionId);
        setSelectedRegionName(regionName);
    }, []);

    const handleResetRegion = () => {
        setSelectedRegionId(undefined);
        setSelectedRegionName("");
    };
     const [getReportPesticides] = useReportPesticidesMutation();
    const openReportModal = () => {
        setShowReportModal(true);
      };
      const getReport = async (payload: { periodStart: string; periodEnd: string; language: string }): Promise<Blob> => {
        return await getReportPesticides(payload).unwrap();
      };
    const isLoading = polygonsLoading || isLoadingPesticides;
    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <PreloaderSvg />
            </div>
        );
    }

    return (
        <div className={style.container}>

            <div className={style.title}>
                <div className={style.title_header}>
                    <h1>{t('Pesticides')}</h1>
                    <Button style={ { marginLeft: '5px' } } type="primary"icon={<img src="../../../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
			  onClick={ () => openReportModal() }>
		{ t('general.generate_report') }
	  </Button>
      <ReportChemicalization
		title={ t('reports.report_by_pesticides') }
		getReport={ getReport }
		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
                </div>
                <div className={style.title_inner}>
                    <img src="../../../homeicon.svg" alt="home" />
                    <p>{t('Home')}</p>
                    <img src="../../../arrowright.svg" alt="arrow" />
                    <p>{t('Mineral fertilizers')}</p>
                    <img src="../../../arrowright.svg" alt="arrow" />
                    <span>{t('Pesticides')}</span>
                </div>
            </div>

            <div className={style.mapcontainer}>

                <PesticidesMap
                    latitude={41.5089324}
                    longitude={74.724091}
                    polygonsData={polygonsData}
                    selectedYear={selectedYear}
                    onYearChange={setSelectedYear}
                    isLoadingFertilizers={isLoading}
                    isLoadingFertilizersOnMap={isLoading}
                    onRegionClick={handleRegionClick}
                    onResetRegion={handleResetRegion}
                    selectedRegionName={selectedRegionName}
                    pesticidesData={pesticidesData}
                    initialRegionId={selectedRegionId}
                />
            </div>
        </div>
    )
}